export default "__VITE_ASSET__032d58e2__"